import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { qrTrackingUrl } from "../../lib/trackAppStore";

export const AppStoreQR = ({ size = 104, testPrefix, display = "hidden md:flex", caption = true }) => (
  <div className={`items-center gap-4 ${display}`} data-testid={`${testPrefix}-qr`}>
    <div className="ss-qr-glow rounded-2xl border border-[#E8EBE9] bg-white p-2.5">
      <QRCodeSVG
        value={qrTrackingUrl(testPrefix)}
        size={size}
        fgColor="#111E16"
        bgColor="#FFFFFF"
        level="M"
        title="Scan to download SisterSafe on the App Store"
      />
    </div>
    {caption && (
      <p className="max-w-[9rem] text-sm leading-snug text-[#4A5F52]">
      Scan with your iPhone camera to download
      </p>
    )}
  </div>
);
